"use strict";
var appn;
(function (appn) {
    var codeMirror;
    (function (codeMirror) {
        function applyToTextArea(textAreaSelector, codeType) {
            if (textAreaSelector.startsWithIgnoreCase('#'))
                textAreaSelector = "textarea" + textAreaSelector;
            if ($(textAreaSelector).length <= 0)
                return null;
            window.currentCodeWindow = textAreaSelector;
            let config = null;
            switch (codeType) {
                case codeTypes.htmlAndScript: {
                    config = getHtmlAndScriptConfig();
                    break;
                }
                case codeTypes.scss: {
                    config = getScssConfig();
                    break;
                }
                case codeTypes.css: {
                    config = getCssConfig();
                    break;
                }
                case codeTypes.json: {
                    config = getJsonConfig();
                    break;
                }
                case codeTypes.formulaBuilder: {
                    config = getFormulaBuilderConfig();
                    break;
                }
            }
            if (!config)
                return null;
            var textarea = $(textAreaSelector).get(0);
            if (textarea.value === undefined)
                textarea.value = '';
            const codeEditor = window.CodeMirror.fromTextArea(textarea, config);
            window.cmResize(codeEditor, {
                minWidth: 300,
                minHeight: 200,
                resizableWidth: true,
                resizableHeight: true
            });
            setTimeout(function () {
                codeEditor.refresh();
            }, 1000);
            return codeEditor;
        }
        codeMirror.applyToTextArea = applyToTextArea;
        function getHtmlAndScriptConfig() {
            return {
                gutters: ['CodeMirror-lint-markers', 'CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
                lint: true,
                styleActiveLine: true,
                lineNumbers: true,
                lineWrapping: true,
                foldGutter: true,
                autoCloseTags: true,
                matchBrackets: true,
                autoCloseBrackets: true,
                continueComments: 'Enter',
                mode: {
                    name: 'htmlmixed',
                    scriptTypes: [
                        {
                            matches: /\/x-handlebars-template|\/x-mustache/i,
                            mode: null
                        },
                        {
                            matches: /(text|application)\/(x-)?vb(a|script)/i,
                            mode: 'vbscript'
                        }
                    ]
                }
            };
        }
        function getScssConfig() {
            return {
                gutters: ['CodeMirror-lint-markers', 'CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
                lineNumbers: true,
                matchBrackets: true,
                autoCloseBrackets: true,
                mode: 'text/x-scss'
            };
        }
        function getCssConfig() {
            return {
                gutters: ['CodeMirror-lint-markers', 'CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
                lint: true,
                lineNumbers: true,
                matchBrackets: true,
                autoCloseBrackets: true,
                mode: 'text/x-gss'
            };
        }
        function getJsonConfig() {
            return {
                gutters: ['CodeMirror-lint-markers', 'CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
                lint: true,
                matchBrackets: true,
                autoCloseBrackets: true,
                mode: 'application/ld+json',
                lineWrapping: true,
                lineNumbers: true
            };
        }
        function getFormulaBuilderConfig() {
            return {
                lineNumbers: false,
                lineWrapping: true,
                matchBrackets: true,
                autoCloseBrackets: true,
                extraKeys: { Tab: 'autocomplete' },
                mode: { name: 'formula', globalVars: true },
                hintOptions: { completeSingle: false }
            };
        }
        function setFormulaBuilderStructuredConfig(editor) {
            editor.setOption('styleActiveLine', true);
            editor.setOption('autoCloseTags', true);
            editor.setOption('continueComments', 'Enter');
            editor.setOption('htmlMode', false);
            editor.setOption('hintOptions', { completeSingle: false });
            editor.setOption('mode', {
                name: 'formula',
                globalVars: true,
                scriptTypes: [
                    {
                        matches: /\/x-handlebars-template|\/x-mustache/i,
                        mode: null
                    },
                    {
                        matches: /(text|application)\/(x-)?vb(a|script)/i,
                        mode: 'vbscript'
                    }
                ]
            });
        }
        codeMirror.setFormulaBuilderStructuredConfig = setFormulaBuilderStructuredConfig;
        let codeTypes;
        (function (codeTypes) {
            codeTypes[codeTypes["htmlAndScript"] = 0] = "htmlAndScript";
            codeTypes[codeTypes["scss"] = 1] = "scss";
            codeTypes[codeTypes["css"] = 2] = "css";
            codeTypes[codeTypes["json"] = 3] = "json";
            codeTypes[codeTypes["formulaBuilder"] = 4] = "formulaBuilder";
        })(codeTypes = codeMirror.codeTypes || (codeMirror.codeTypes = {}));
    })(codeMirror = appn.codeMirror || (appn.codeMirror = {}));
})(appn || (appn = {}));
